module.exports = __webpack_public_path__ + "static/FeatureRequest-8cc849911086b45611a45c8d04ee3460.png";